import Home from './pages/Home';
import Permit from './pages/Permit';
import AppendixA from './pages/appendix/A';
import AppendixB from './pages/appendix/B';
import AppendixC from './pages/appendix/C';
import AppendixD from './pages/appendix/D';
import AppendixE from './pages/appendix/E';
import AppendixF from './pages/appendix/F';
import AppendixG from './pages/appendix/G';
import AppendixH from './pages/appendix/H';
import AppendixI from './pages/appendix/I';
import AppendixJ from './pages/appendix/J';

const router = [
  // {
  //   path: '/',
  //   children: [
  {
    path: 'permit',
    element: <Permit />,
  },
  // {
  //   path: 'only/:yearmonth',
  //   element: <Home hideControls />,
  // },
  // {
  //   path: 'only',
  //   children: [
  //     {
  //       path: ':yearmonth',
  //       element: <Home hideControls />,
  //     },
  //   ],
  // },
  {
    path: ':yearmonth/only',
    element: <Home hideControls />,
  },
  {
    //   // path: '/:year-:month',
    //   // path: '/2023-9',
    path: ':yearmonth',
    element: <Home />,
  },
  // {
  //   path: ':yearmonth',
  //   children: [
  //     {
  //       path: '',
  //       element: <Home />,
  //     },
  //     {
  //       path: 'only',
  //       element: <Home hideControls />,
  //     },
  //   ],
  // },
  {
    path: 'appendix/a',
    element: <AppendixA />,
  },
  {
    path: 'appendix/b',
    element: <AppendixB />,
  },
  {
    path: 'appendix/c/:yearmonth',
    element: <AppendixC />,
  },
  {
    path: 'appendix/d/:yearmonth',
    element: <AppendixD />,
  },
  {
    path: 'appendix/e/:yearmonth',
    element: <AppendixE />,
  },
  {
    path: 'appendix/f/:yearmonth',
    element: <AppendixF />,
  },
  {
    path: 'appendix/g/:yearmonth',
    element: <AppendixG />,
  },
  {
    path: 'appendix/h/:yearmonth',
    element: <AppendixH />,
  },
  {
    path: 'appendix/i/:yearmonth',
    element: <AppendixI />,
  },
  {
    path: 'appendix/j/:yearmonth',
    element: <AppendixJ />,
  },
  {
    path: '',
    element: <Home />,
  },
  //   ],
  // },
];

export default router;
